// SAD-900: shared CLIN / PWS / team / status / source-doc / period filter
// selects for every deliverables and dates table.
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { SpecraSelect } from '@mono/ui-components';
function Select({ label, value, onChange, options, allLabel, testId, size, prepend }) {
    if (options.length === 0 && !prepend?.length) return null;
    return /*#__PURE__*/ _jsxs(SpecraSelect, {
        "aria-label": label,
        size: size,
        className: "w-44",
        value: value,
        onChange: (e)=>onChange(e.target.value),
        "data-testid": testId,
        children: [
            /*#__PURE__*/ _jsx("option", {
                value: "",
                children: allLabel
            }),
            (prepend ?? []).map((o)=>/*#__PURE__*/ _jsx("option", {
                    value: o.value,
                    children: o.label
                }, o.value)),
            options.map((o)=>/*#__PURE__*/ _jsx("option", {
                    value: o.value,
                    children: o.label
                }, o.value))
        ]
    });
}
/** Compact filter selects for deliverable / date tables. */ export function DeliverableFilters({ values, onChange, options, show, testIds, contractWideTeam = true, periodAllLabel = 'All periods', size = 'sm' }) {
    const s = {
        clin: show?.clin !== false,
        pws: show?.pws !== false,
        team: show?.team !== false,
        status: show?.status !== false,
        sourceDoc: show?.sourceDoc !== false,
        period: show?.period !== false
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            s.clin ? /*#__PURE__*/ _jsx(Select, {
                label: "CLIN",
                value: values.clin ?? '',
                onChange: (v)=>onChange('clin', v),
                options: options.clins ?? [],
                allLabel: "All CLINs",
                testId: testIds?.clin,
                size: size
            }) : null,
            s.pws ? /*#__PURE__*/ _jsx(Select, {
                label: "PWS section",
                value: values.pws ?? '',
                onChange: (v)=>onChange('pws', v),
                options: options.pws ?? [],
                allLabel: "All PWS",
                testId: testIds?.pws,
                size: size
            }) : null,
            s.team ? /*#__PURE__*/ _jsx(Select, {
                label: "Team",
                value: values.team ?? '',
                onChange: (v)=>onChange('team', v),
                options: options.teams ?? [],
                allLabel: "All teams",
                testId: testIds?.team,
                size: size,
                prepend: contractWideTeam ? [
                    {
                        value: 'contract-wide',
                        label: 'Contract-wide'
                    }
                ] : undefined
            }) : null,
            s.status ? /*#__PURE__*/ _jsx(Select, {
                label: "Status",
                value: values.status ?? '',
                onChange: (v)=>onChange('status', v),
                options: options.statuses ?? [],
                allLabel: "All statuses",
                testId: testIds?.status,
                size: size
            }) : null,
            s.sourceDoc ? /*#__PURE__*/ _jsx(Select, {
                label: "Source document",
                value: values.sourceDoc ?? '',
                onChange: (v)=>onChange('sourceDoc', v),
                options: options.sourceDocs ?? [],
                allLabel: "All sources",
                testId: testIds?.sourceDoc,
                size: size,
                prepend: [
                    {
                        value: 'none',
                        label: 'No document'
                    }
                ]
            }) : null,
            s.period ? /*#__PURE__*/ _jsx(Select, {
                label: "Period",
                value: values.period ?? '',
                onChange: (v)=>onChange('period', v),
                options: options.periods ?? [],
                allLabel: periodAllLabel,
                testId: testIds?.period,
                size: size
            }) : null
        ]
    });
}
